import { Component, OnInit, inject } from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {Store} from '@ngrx/store';
import {AsyncPipe, NgTemplateOutlet} from '@angular/common';
import {filter, map, Observable, switchMap, take} from 'rxjs';
import {IconComponent} from '../../../../shared/icons/icon.component';
import {TextWithIconComponent} from '../../../../shared/components/text-with-icon/text-with-icon.component';
import {IconsPipe} from '../../../../shared/pipes/icons.pipe';
import {selectRuleById} from '../../state/rule.selectors';
import {CardComponent} from '../../../../shared/components/card/card.component';
import {RouteConstants} from '../../../../shared/constants/route-constants';
import {RuleViewModel} from '../../models/rule-view-model.interface';
import {LabelConverter} from '../../../../shared/converter/label.converter';
import {FormsModule} from '@angular/forms';
import {TimePipe} from '../../../../shared/pipes/time.pipe';
import {RuleActions} from '../../state/rule.actions';
import {ConfirmDialogComponent, ConfirmDialogData} from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {RuleListComponent} from '../../components/rule-list/rule-list.component';
import {RepetitionMode, WeekDays} from '@birco/rainmesh-api';
import {LocalizedPercentPipe} from '../../../../shared/pipes/localized-percent.pipe';
import {RuleNamePipe} from '../../pipes/rule-name.pipe';
import { TagComponent } from "../../../../shared/components/tag/tag.component";

@Component({
  selector: 'app-page-rule-detail',
  imports: [
    CardComponent,
    IconComponent,
    TranslatePipe,
    RouterLink,
    TextWithIconComponent,
    AsyncPipe,
    IconsPipe,
    FormsModule,
    NgTemplateOutlet,
    LocalizedPercentPipe,
    TimePipe,
    RuleListComponent,
    RuleNamePipe,
    TagComponent
],
  templateUrl: './page-rule-detail.component.html',
  styleUrl: './page-rule-detail.component.scss'
})
export class PageRuleDetailComponent implements OnInit {
  private store = inject(Store);
  private route = inject(ActivatedRoute);
  private dialog = inject(MatDialog);
  private translateService = inject(TranslateService);

  rule$!: Observable<RuleViewModel | null>;

  ngOnInit() {
    // todo added error handling (404)
    this.rule$ = this.route.paramMap?.pipe(
      map(params => params.get('id')),
      filter((id): id is string => !!id),
      switchMap(id => this.store.select(selectRuleById(id)))
    );
  }

  sortWeekDays(weekDays: WeekDays[]): WeekDays[] {
    const weekDayOrder = [
      WeekDays.MONDAY,
      WeekDays.TUESDAY,
      WeekDays.WEDNESDAY,
      WeekDays.THURSDAY,
      WeekDays.FRIDAY,
      WeekDays.SATURDAY,
      WeekDays.SUNDAY
    ];
    return [...weekDays].sort((a, b) => weekDayOrder.indexOf(a) - weekDayOrder.indexOf(b));
  }

  protected readonly RouteConstants = RouteConstants;
  protected readonly LabelConverter = LabelConverter;
  protected readonly RepetitionMode = RepetitionMode;
}
